import {
    FETCH_ESB_REFERENCE_DATA_BEGIN,
    FETCH_ESB_REFERENCE_DATA_SUCCESS,
    FETCH_ESB_REFERENCE_DATA_FAILURE
} from '../../../Actions/FormServiceActions/MplFormServices/GetEsbReferenceDataAction';

const initialState = {
    referenceData: {},
    error: null,
    loaded: false
};

export default function getEsbReferenceData(state = initialState, action) {
    switch (action.type) {
        case FETCH_ESB_REFERENCE_DATA_BEGIN:
            return {
                ...state,
                error: null,
                loaded: false,
                referenceData: {}
            };

        case FETCH_ESB_REFERENCE_DATA_SUCCESS:
            return {
                ...state,
                referenceData: action.payload,
                loaded: true,
                error: null
            };

        case FETCH_ESB_REFERENCE_DATA_FAILURE:
            return {
                ...state,
                error: action.payload.error,
                referenceData: {},
                loaded: false
            };

        default:
            return state;
    }
}